import api, { baseURL } from "@/libs/axios";
import { apiEnum } from "@/pages/taskpane/shared/types/enums/apiEnum";
import { buildUrlWithQueryString } from "../../api/functionApi";
import { DialogService, IDialogModel } from "../../utils/dialog";
import { ICheckMoveOrderRequest, ICheckResourceSuitableForMovingOrderResponse, IDeleteReservationTempRequest, IOpenOrderRequest, ISaveMovingOrderTempRequest, ISavePlaceOrderSessionDataRequest, IViewMovingOrderRequest } from "../types/OrderEntity";

export interface IOrderService {
  openOrder(request: IOpenOrderRequest, callback: (dialog: IDialogModel) => void): void;
  viewMovingOrder(request: IViewMovingOrderRequest, callback: (dialog: IDialogModel) => void): void;
  savePlaceOrderSessionData(request: ISavePlaceOrderSessionDataRequest): Promise<{ Success: boolean }>;
  checkResourceSuitableForMovingOrder(request: ICheckMoveOrderRequest):  Promise<ICheckResourceSuitableForMovingOrderResponse>;
  createMovingOrderTemp(request: ISaveMovingOrderTempRequest): Promise<{ Success: boolean }>;
  deleteTempReservation(request: IDeleteReservationTempRequest): Promise<{ Success: boolean }>;
}

export class OrderService implements IOrderService {
  private readonly _apiUrl = `${baseURL}/ResourceCentral`;
  private readonly _dialogService = new DialogService();
  private readonly _isFrom = "Outlook Add-in";

  openOrder(request: IOpenOrderRequest, callback: (dialog: IDialogModel) => void): void {
    const url = buildUrlWithQueryString(`${this._apiUrl}${apiEnum.openOrder}`, request);
    this._dialogService.ShowDialog(
      url,
      {
        Width: 90,
        Height: 80,
      },
      callback
    );
  }

  viewMovingOrder(request: IViewMovingOrderRequest, callback: (dialog: IDialogModel) => void): void {
    const url = buildUrlWithQueryString(`${this._apiUrl}${apiEnum.viewMovingOrder}`, request);
    this._dialogService.ShowDialog(url, { Width: 50, Height: 50 }, callback);
  }

  async savePlaceOrderSessionData(request: ISavePlaceOrderSessionDataRequest): Promise<{ Success: boolean }> {
    const url = `${this._apiUrl}${apiEnum.savePlaceOrderSessionData}`;
    const response = await api.post(url, request, {
      headers: {
        IsFrom: this._isFrom,
      },
    });
    return response.data as { Success: boolean };
  }

  async checkResourceSuitableForMovingOrder(request: ICheckMoveOrderRequest): Promise<ICheckResourceSuitableForMovingOrderResponse> {
    const url = `${this._apiUrl}${apiEnum.checkResourceSuitableForMovingOrder}`;
    const response = await api.post(url, request, {
      headers: {
        IsFrom: this._isFrom,
      },
    });
    return response.data as ICheckResourceSuitableForMovingOrderResponse;
  }

  async createMovingOrderTemp(request: ISaveMovingOrderTempRequest): Promise<{ Success: boolean }> {
    const url = `${this._apiUrl}${apiEnum.createMovingOrderTemp}`;
    const response = await api.post(url, request, {
      headers: {
        IsFrom: this._isFrom,
      },
    });
    return response.data as { Success: boolean };
  }

  async deleteTempReservation(request: IDeleteReservationTempRequest): Promise<{ Success: boolean }> {
    const url = `${this._apiUrl}${apiEnum.deleteTempReservation}`;
    const response = await api.post(url, request, {
      headers: {
        IsFrom: this._isFrom,
      },
    });
    return response.data as { Success: boolean };
  }
}
